import { formatCount, formatRate } from '../../../lib/outreach/stats'
import { rangeLabel } from './format'

/** The fields both a single business and the all-businesses roll-up provide. */
export interface KpiTotals {
  sent_today: number
  sent_7d: number
  sent_30d: number
  sent: number
  replies: number
  bounces: number
  optouts: number
  reply_rate: number | null
  bounce_rate: number | null
  queued: number
  due_today: number
}

interface TileProps {
  label: string
  value: string
  sub?: string
}

function Tile({ label, value, sub }: TileProps) {
  return (
    <div className="stat-cell" role="group" aria-label={label}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub && <div className="od-sub">{sub}</div>}
    </div>
  )
}

export function KpiTiles({ totals, days }: { totals: KpiTotals; days: number }) {
  const range = rangeLabel(days)
  const ofSent = `of ${formatCount(totals.sent)} sent, ${range}`
  return (
    <div className="stats-bar cols4">
      <Tile label="Sent today" value={formatCount(totals.sent_today)} />
      <Tile label="Sent 7 days" value={formatCount(totals.sent_7d)} />
      <Tile label="Sent 30 days" value={formatCount(totals.sent_30d)} />
      <Tile
        label="Replies"
        value={formatCount(totals.replies)}
        sub={`${formatRate(totals.reply_rate)} ${ofSent}`}
      />
      <Tile
        label="Bounces"
        value={formatCount(totals.bounces)}
        sub={`${formatRate(totals.bounce_rate)} ${ofSent}`}
      />
      <Tile label="Opt-outs" value={formatCount(totals.optouts)} sub={range} />
      <Tile label="Still to contact" value={formatCount(totals.queued)} />
      <Tile label="Due today" value={formatCount(totals.due_today)} />
    </div>
  )
}
